module.exports = __webpack_public_path__ + "static/media/cr.46b19aa9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cr.svg
// module id = 627
// module chunks = 0